const useTemplateServiceParams = () => {
  const url = new URL(window.location);
  const initTemplate = url.searchParams.get("initTemplate");
  const savedTemplatesGetUrl = url.searchParams.get("savedTemplatesGetUrl");
  const showPremadeTemplates = url.searchParams.get("showPremadeTemplates");
  const applyTemplateUrl = url.searchParams.get("applyTemplateUrl");
  const savedTemplatesSaveUrl = url.searchParams.get("savedTemplatesSaveUrl");

  return {
    initTemplate,
    savedTemplatesGetUrl,
    showPremadeTemplates,
    applyTemplateUrl,
    savedTemplatesSaveUrl,
  };
};
export default useTemplateServiceParams;
